export default {"src":"/_next/static/media/charthop-logo.775dd16c.svg","height":61,"width":190};